export function parseSetupKeyFromProvisioningUri(provisioningUri: string): string {
  if (!provisioningUri) {
    return '';
  }

  try {
    return new URL(provisioningUri).searchParams.get('secret') || '';
  } catch {
    const match = provisioningUri.match(/[?&]secret=([^&]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }
}
